<template>
    <v-dialog 
        v-model="showCreate"
        v-if="showCreate"
        persistent
        max-width="800"
        @click:outside="closeModal"
    >
        <validation-observer v-slot="{ handleSubmit }">
            <div class="topic-create-wrapper">
                <div class="topic-create-header">
                    <span v-if="isCreate" class="topic-create-name">
                        TẠO TOPIC
                    </span>
                    <span v-else class="topic-create-name">
                        SỬA TOPIC
                    </span>
                    <v-icon
                        size="24" 
                        @click="closeModal"
                    >
                        mdi-close
                    </v-icon>
                </div>
                <div class="topic-create-form" v-if="isCreate">
                    <div class="input-form" v-for="(item, index) in list" :key="index">
                        <div class="topic-create-label pt-3">
                            Tên Topic *
                        </div>
                        <div class="input-wrapper col py-0 pl-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Tên Topic"
                            >
                                <v-text-field
                                    class="topic-create-input"
                                    placeholder="Nhập tên topic..."
                                    v-model="item.name"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                        <button 
                            v-if="index == 0"
                            class="topic-create-add"
                            @click="addTopic()"
                            title="Thêm Topic"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </button>
                        <button 
                            v-else
                            class="topic-create-add"
                            @click="removeTopic(item.id)"
                            title="Xóa Topic"
                        >
                            <v-icon>mdi-minus</v-icon>
                        </button>
                    </div>
                </div>
                <div class="topic-create-form" v-else>
                    <div class="input-form">
                        <div class="topic-create-label pt-3">
                            Tên Topic *
                        </div>
                        <div class="input-wrapper col py-0 px-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Tên Topic"
                            >
                                <v-text-field
                                    class="topic-create-input"
                                    placeholder="Nhập tên topic..."
                                    v-model="topic.name"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                    </div>
                </div>
                <div class="col text-center">
                    <button
                        class="cancel-btn"
                        @click="closeModal"
                    >
                        BỎ QUA
                    </button>
                    <button
                        class="accept-btn"
                        @click="handleSubmit(saveTopic)"
                    >
                        LƯU
                    </button>
                </div>
            </div>
        </validation-observer>
    </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        showCreate: {
            type: Boolean,
            default: false
        },
        isCreate: {
            type: Boolean,
            default: true
        },
        topic: {
            type: Object,
            default: () => {}
        },
        list: {
            type: Array,
            default: () => {[]}
        },
        allowCreateTopic: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            
        }
    },

    methods: {
        closeModal() {
            Bus.$emit('close-create-topic-modal')
        },

        addTopic() {
            this.list.push({
                name: '',
                error: '',
                id: moment().unix()
            })
        },
        
        removeTopic(id) {
            let index = this.list.findIndex(t => t.id == id)
            
            if (index > -1) {
                this.list.splice(index, 1)
            }
        },

        saveTopic() {
            if (this.allowCreateTopic) {
                Bus.$emit('action-create-topic')
                if (this.isCreate) {
                    let errorName = []
                    this.list.forEach(item => {
                        let filter = this.list.filter(i => i.name.toLowerCase() == item.name.toLowerCase())

                        if (filter.length > 1 && !errorName.includes(item.name.toLowerCase())) {
                            errorName.push(item.name.toLowerCase())
                        }
                    })

                    if (errorName.length) {
                        this.$swal({
                            title: 'Lỗi!',
                            text: `Topic ${errorName.join(', ')} bị trùng tên trong danh sách`
                        })
                    } else {
                        Bus.$emit('save-topic-role', this.list)
                    }
                } else {
                    Bus.$emit('save-topic-role', this.topic)
                }
            }
        }
    }
}
</script>

<style scoped>
.topic-create-wrapper {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
}

.topic-create-header {
    padding: 15px 0px;
    margin: 0px 20px 0px 30px;
    border-bottom: 1px solid #E0E0E0;
}

.topic-create-header i {
    float: right;
    cursor: pointer;
}

.topic-create-name {
    font-size: 20px;
    font-weight: 600;
}

.topic-create-label {
    font-size: 16px;
}

.input-form {
    display: flex;
    width: 100%;
    padding: 10px 20px 25px 30px;
}

.input-wrapper {
    height: 48px;
}

.topic-create-input {
    width: 100%;
    background-color: #F8F8F8;
    height: 100%;
    padding: 5px 20px;
    font-size: 16px;
    outline: unset;
    border-radius: 8px;
}

.topic-create-add {
    width: 48px;
    height: 48px;
    background-color: white;
    border: 1px dashed #BDBDBD;
    border-radius: 8px;
}

.topic-create-add i {
    color: black;
    font-size: 24px;
}

.cancel-btn {
    background-color: #F2F2F2;
    width: 192px;
    height: 56px;
    font-size: 16px;
    color: #828282;
    font-weight: 700;
    border-radius: 8px;
    margin-right: 24px;
}

.accept-btn {
    background-color: #7367F0;
    width: 192px;
    height: 56px;
    font-size: 16px;
    color: white;
    font-weight: 700;
    border-radius: 8px;
}
</style>